import config from './config';

const PORTAL_AUTH = {
  CSS_PORTAL: config.cognito,
  INSTALLER_PORTAL: config.cognito.installerPortal || config.cognito,
  INVOICE_PORTAL: config.cognito.invoicePortal || config.cognito,
};

const getPathname = pathname => {
  if (typeof pathname === 'string') {
    return pathname;
  }
  if (typeof window === 'undefined') {
    return '';
  }
  return window.location?.pathname || '';
};

const detectPortal = pathname => {
  const path = getPathname(pathname);
  if (path.startsWith('/installer')) {
    return 'INSTALLER_PORTAL';
  }
  if (path.startsWith('/invoice-payment')) {
    return 'INVOICE_PORTAL';
  }
  return 'CSS_PORTAL';
};

const awsExports = pathname => ({
  Auth: PORTAL_AUTH[detectPortal(pathname)],
});

export { detectPortal };
export default awsExports;
